import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { toast } from "react-toastify";

import i18n from "../../i18n";
import getAPIbaseURL from "../../utils/helpers";

const API_URL = `${getAPIbaseURL()}/shifts/templates`;

export const fetchShiftTemplates = createAsyncThunk("shiftTemplates/fetch", async (_, thunkAPI) => {
    try {
        const response = await axios.get(API_URL, {
            headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
        });
        return response.data;
    } catch (error) {
        return thunkAPI.rejectWithValue(error.response?.data || error.message);
    }
});

export const updateShiftTemplates = createAsyncThunk("shiftTemplates/update", async (templates, thunkAPI) => {
    try {
        const response = await axios.put(API_URL, { templates }, {
            headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
        });
        toast.success(i18n.t("components.ShiftTemplatesTab.saved"));
        return response.data;
    } catch (error) {
        toast.error(i18n.t("components.ShiftTemplatesTab.saveError"));
        return thunkAPI.rejectWithValue(error.response?.data || error.message);
    }
});

const shiftTemplateSlice = createSlice({
    name: "shiftTemplates",
    initialState: { item: null, isLoading: false, error: null },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchShiftTemplates.pending, (state) => { state.isLoading = true; })
            .addCase(fetchShiftTemplates.fulfilled, (state, action) => {
                state.isLoading = false;
                state.item = action.payload;
                state.error = null;
            })
            .addCase(fetchShiftTemplates.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload;
            })
            .addCase(updateShiftTemplates.pending, (state) => { state.isLoading = true; })
            .addCase(updateShiftTemplates.fulfilled, (state, action) => {
                state.isLoading = false;
                state.item = action.payload;
                state.error = null;
            })
            .addCase(updateShiftTemplates.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload;
            });
    },
});

export default shiftTemplateSlice.reducer;
